import knbUse from '../knb/knb-use'
import Agent from '../agent/base'

export function onVisibilityChange(fn: Function): Function {
  if (Agent.android && Agent.miniprogram) {
    // 从微信7.0.3开始，webview内可以通过判断下面的方式判断小程序是否在前台
    window.WeixinJSBridge.on('onPageStateChange', (res: { active: boolean }) => {
      // console.log('onPageStateChange', res.active)
      fn({
        hidden: !res.active,
      })
    })
  } else if (Agent.android_Ios_HarmonyNative) {
    ;['foreground', 'appear', 'background', 'disappear'].forEach((action) => {
      knbUse('subscribe', {
        action,
        handle: () => {
          fn({
            hidden: ['foreground', 'appear'].indexOf(action) !== -1 ? false : true,
            action,
          })
        },
      })
    })
  } else {
    document.addEventListener('visibilitychange', _fn, false)
  }
  return function unlisten() {
    if (Agent.android && Agent.miniprogram) {
      // do nothing
    } else if (Agent.android_Ios_HarmonyNative) {
      ;['foreground', 'appear', 'background', 'disappear'].forEach((action) => {
        knbUse('unsubscribe', {
          action,
        })
      })
    } else {
      document.removeEventListener('visibilityChange', _fn, false)
    }
  }

  function _fn() {
    // console.log('onVisibilityChange' + !hidden)
    const _hidden = document.visibilityState === 'hidden'
    fn({ hidden: _hidden })
  }
}

/**
 * 用于 import 指定目录下全部组件
 * @param {*} context https://webpack.js.org/guides/dependency-management
 */
export function importAll(context: __WebpackModuleApi.RequireContext) {
  const map: Record<string, any> = {}
  for (const key of context.keys()) {
    const keyArr = key.split('/')
    keyArr.shift()
    const isVue = key.indexOf('vue') !== -1
    map[keyArr.join('.').replace(/\.(vue|js)$/g, '')] = isVue ? context(key).default : context(key)
  }
  console.log(map)
  return map
}

export function scrollToTop() {
  if (document.documentElement.scrollTop !== 0 && typeof document.documentElement.scrollTo === 'function') {
    setTimeout(() => {
      document.documentElement.scrollTo(0, 0)
    })
    return
  }
  if (document.body.scrollTop !== 0 && typeof document.body.scrollTo === 'function') {
    document.body.scrollTo(0, 0)
    return
  }
  if (window.pageYOffset) {
    window.scrollTo(0, 0)
  }
}
